import BaseHandler from "../BaseHandler";
import store from "../../store";
import { getStorage } from "../../libs/storage";
import { STORAGE_USER_ID } from "../../constants/localstorage";
import { UserAvatarDeleteResponse } from "../../proto/UserAvatarDelete_pb";
import { removeAvatar } from "../../store/avatars/actions";
import { updateUser } from "../../store/users/actions";
import { last } from "lodash";
import { editRoom } from "../../store/rooms/actions";

export default class HandleUserAvatarDeleteResponse extends BaseHandler<UserAvatarDeleteResponse> {
  handle() {
    const userAvatarDeleteResponse = this.response.toObject();
    store.dispatch(
      removeAvatar({
        roomId: getStorage(STORAGE_USER_ID),
        avatarId: userAvatarDeleteResponse.id,
      })
    );
    const lastRoomAvatarId = last(store.getState().avatars.roomAvatars[getStorage(STORAGE_USER_ID)]);
    const avatars = store.getState().avatars.avatars;
    let userNewAvatar = undefined;
    if (lastRoomAvatarId && lastRoomAvatarId in avatars) {
      userNewAvatar = avatars[lastRoomAvatarId];
    }
    store.dispatch(
      updateUser({
        userId: getStorage(STORAGE_USER_ID),
        values: {
          avatar: userNewAvatar,
        },
      })
    );
  }
}
